import { Action } from '@ngrx/store';
import { FollowUpModel } from '..';
import { QueryParamsModel } from '../../_base/crud';

export enum FollowUpActionTypes {
  AllFollowUpRequested = '[FollowUp Module] All FollowUp Requested',
  AllFollowUpLoaded = '[FollowUp API] All FollowUp Loaded',
  FollowUpPageRequested = '[FollowUp List Page] FollowUp Page Requested',
  FollowUpPageLoaded = '[FollowUp API] FollowUp Page Loaded',
  FollowUpPageCancelled = '[FollowUp API] FollowUp Page Cancelled',
  FollowUpPageToggleLoading = '[FollowUp] FollowUp Page Toggle Loading',
  FollowUpActionToggleLoading = '[FollowUp] FollowUp Action Toggle Loading',
  ActivityPageRequested = '[FollowUp] Activity Page Requested',
  ThrowFollowUpError = '[FollowUp] Throw Error',
  ClearFollowUpErrors = '[FollowUp] Clear Errors',
}

export class ThrowFollowUpError implements Action {
  readonly type = FollowUpActionTypes.ThrowFollowUpError;

  constructor(public payload: { error: any }) {}
}

export class ClearFollowUpErrors implements Action {
  readonly type = FollowUpActionTypes.ClearFollowUpErrors;
}

export class FollowUpPageRequested implements Action {
  readonly type = FollowUpActionTypes.FollowUpPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class FollowUpPageLoaded implements Action {
  readonly type = FollowUpActionTypes.FollowUpPageLoaded;

  constructor(
    public payload: { followUp: FollowUpModel[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class FollowUpPageCancelled implements Action {
  readonly type = FollowUpActionTypes.FollowUpPageCancelled;
}

export class FollowUpPageToggleLoading implements Action {
  readonly type = FollowUpActionTypes.FollowUpPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class FollowUpActionToggleLoading implements Action {
  readonly type = FollowUpActionTypes.FollowUpActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type FollowUpActions =
  | FollowUpPageLoaded
  | FollowUpPageCancelled
  | FollowUpPageToggleLoading
  | FollowUpPageRequested
  | ThrowFollowUpError
  | ClearFollowUpErrors
  | FollowUpActionToggleLoading;
